export default "__VITE_ASSET__Dgdd9kgx__"